import { styled, Typography } from '@mui/material';

export const PlaygroundContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  marginTop: theme.spacing(3),
  height: 'calc(100vh - 200px)', // minus header
}));

export const UrlBuilderContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.border.radius,
  border: theme.border.default,
  width: '700px',
  minWidth: '700px',
  height: 'fit-content',
  maxHeight: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

export const UrlViewerContainer = styled('div')(({ theme }) => ({
  width: '400px',
  alignSelf: 'flex-start',
  backgroundColor: '#000',
  borderRadius: theme.border.radius,
  boxShadow: theme.border.boxShadow,
  padding: theme.spacing(2, 3, 3, 3),
  flexGrow: 1,
  minHeight: '300px',
  color: theme.palette.common.white,
}));

export const FormFields = styled('div')(({ theme }) => ({
  padding: theme.spacing(1, 3),

  ...theme.scrollShadows,
  ...theme.styledScrollbar,
}));

export const Footer = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const PermissionCount = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.bold.fontFamily,
  fontSize: theme.typography.body2.fontSize,
}));

export const ButtonsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
}));

